import { render, staticRenderFns } from "./MFACodeValidation.vue?vue&type=template&id=4a6aafac&scoped=true"
import script from "./MFACodeValidation.vue?vue&type=script&lang=js"
export * from "./MFACodeValidation.vue?vue&type=script&lang=js"
import style0 from "./MFACodeValidation.vue?vue&type=style&index=0&id=4a6aafac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6aafac",
  null
  
)

export default component.exports